import swal from "sweetalert";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import useUser from "../../../../../core/hooks/use-user";
import useModal from "../../../../../core/hooks/use-modal";
import FormAsignarCuadroTurno from "../form-asignar-cuadro-turnos";

const BotonAsignarTurno = ({ onTurnoAsignado }) => {
    const { userCan } = useUser();
    const modalAsignarTurno = useModal();

    const onCreateCuadroTurno = async (response) => {
        let { errors } = response;

        if (errors && errors.length > 0) {
            errors = errors
                .map((err) => `* ${err.empleado} - ${err.fecha_cuadro_turno}`)
                .join("\n");

            await swal({
                icon: "error",
                title: "Error!",
                text: `
                    ${errors} \n
                    Estos turnos no han sido creados ya que se excede el máximo
                    de horas de trabajo que pueden tener estos empleados en esos días
                `,
            });
        }

        onTurnoAsignado();
    };

    if (userCan("nominaAsignarTurno")) {
        return (
            <>
                <Button
                    color="secondary"
                    title="Asignar turno"
                    onClick={() => modalAsignarTurno.open()}
                >
                    <i className="fas fa-plus mr-1"></i>
                    Asignar turno
                </Button>
                <FormAsignarCuadroTurno
                    modalState={modalAsignarTurno}
                    onCreate={onCreateCuadroTurno}
                />
            </>
        );
    }

    return <></>;
};

BotonAsignarTurno.propTypes = {
    onTurnoAsignado: PropTypes.func,
};

export default BotonAsignarTurno;
